import styled from 'styled-components'
import {maxWidth} from 'resources/react/core/theme'
import {darken} from 'polished'

export const Wrapper = styled.div`

    .header {
        display: flex;
        justify-content: center;

        p {
            font-size: 39px;
        }
    }

    .button-orange-invert {
        padding: 10px 0px !important;
        font-size: 13px;
        width: 159px;
        background: transparent;
        color: #fe5147;
        border: 1px solid #fe5147;
        display: block;
        text-align: center;

        p {
            font-size: 13px;
            color: #fff;
            margin: 0px;
        }
    }    

    .button-orange {
        padding: 10px !important;
        font-size: 13px !important;
        margin-top: 10px;
        width: 159px;
        background: #fe5147;
        color: #fff;
        border: none;
        display: block;
        text-align: center;

        p {
            font-size: 13px;
            color: #fff;
            margin: 0px;
        }
    }

    p {
        color: #333;
        font-size: 20px;
        line-height: 1.5;
    }

    .section-1 {
        display: flex;
        justify-content: center;
        padding-top: 40px;
        padding-bottom: 60px;

        .text-wrap {
            p {
                margin: 0px;
            }

            a {
                font-size: 20px;
            }
            h2 {
                margin-top: 0px;
            }

            max-width: 588px;
            padding-left: 25px;
        }
    }

    .img-wrap > div {
        display: flex;
        align-items: center;
    }    

    .section-1-img,
    .section-2-img {
        width: 384px;
        height: 384px;
    }

    .section-2 {
        display: flex;
        justify-content: center;

        a {
            font-size: 13px;
        }

        .text-wrap {

            h2 {
                margin-top: 0px;
            }
            
            max-width: 588px;
            padding-right: 25px;
        }
    } 
    
    .carousel {
        padding: 50px 0px;

        .mobile-slider {
            display: none;
        }

        a {
            text-align: center;
        }

        .text-wrap {

            display: flex;
            justify-content: center;
            flex-direction: column;

            h4 {
                margin-top: 0px;
                margin-bottom: 10px;
                text-align: center;
            }

            .sub-heading {
                display: flex;
                justify-content: center;
                
                span {
                    max-width: 792px;
                    text-align: center;
                }
            }
        }

        .img-wrap {
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding-top: 25px;

            div {
                display: flex;
                flex-direction: column;
            }
        }
    }

    .section-3,
    .section-5 {
        background-color: #f8f8f8;
    }

    .section-3-logo {
        width: 180px;
        height: 180px;
        margin-bottom: 25px;
    }

    .section-3-logo + p {
        text-align: center;
        font-size: 32px;
        max-width: 384px;
        line-height: 36px;
    }
    
    .section-link {
        font-size: 13px;
    }

    .section-6 {
        display: flex;
        flex-direction: row-reverse;
        justify-content: center;
        padding-top: 40px;
        padding-bottom: 20px;

        a {
            font-size: 13px;
        }

        .text-wrap {

            h2 {
                margin-top: 0px;
            }
            
            max-width: 588px;
            padding-left: 25px;
        }

        .section-6-img {
            width: 385px;
            height: 385px;
        }

        .section-6-img-2 {
            width: 180px;
            margin-top: 30px;
        }        
    }    

    h2 {
        padding: 0;
    }

    h2 {
        p {
            font-size: 39px;
        }
    }

    h3 {
        margin: 40px 0 15px;
        padding: 0;
    }
    a {
        color: #4a90e2;
        text-decoration: none;
        transition: color 200ms ease;
        font-size: 16px;
        &:hover,
        &:focus {
            color: ${() => darken(.15, '#4a90e2')};
        }
    }


    ${maxWidth.small`
        .carousel {
            padding-bottom: 70px;
            
            .text-wrap {
                h4 {
                    text-align: left;
                }
            }
        }

        img {
            height: 100% !important;
        }    
        .slick-track {
            // margin-left: 100px;
        }

        .slick-dots {
            bottom: -27px;

            li {
                margin: 0px;
            }
        }

    `}
    ${maxWidth.medium`

        .slick-dots li.slick-active button:before {
            color: #007acc;
        }

        .slick-dots {
            bottom: -38px;
        }

        ,start {
            // color: #007acc;
        }
        .active {
            color: #007acc !important;
        }

        .next_arrow {
            display: block;
            font-size: 30px;
            position: absolute;
            z-index: 999;
            right: 35%;
            top: 103%;
            transform: rotate(90deg);
            cursor: pointer;
            color: #bababa;
        }

        .prev_arrow {
            display: block;
            font-size: 30px;
            position: absolute;
            z-index: 999;
            left: 35%;
            top: 103%;
            transform: rotate(-90deg);
            cursor: pointer;
            color: #bababa;
        }    

        h2 {
            p {
                font-size: 31px;
            }
        }

        p {
            color: #333;
            font-size: 18px;
            line-height: 1.33;
        }

        .anchored-nav {
            width: 320px !important;
        }

        .header {
            justify-content: left;
            padding-left: 15px;
            padding-right: 15px;
        }

        .section-1 {
            padding-left: 15px;
            padding-right: 15px;
            flex-direction: column;
            padding-bottom: 40px;

            .img-wrap {
                display: flex;
                justify-content: center;
            }

            .text-wrap {
                max-width: 100%;
                padding-left: 0px;
                padding-top: 25px;
                line-height: 24px;
            }
        }

        .section-2 {
            padding-left: 15px;
            padding-right: 15px;
            flex-direction: column-reverse;
            padding-bottom: 20px;

            .img-wrap {
                display: flex;
                justify-content: center;
            }

            .text-wrap {
                line-height: 24px;
                max-width: 100%;
                padding-top: 25px;
            }
        }

        .slide-wrap {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .carousel {
            padding-left: 15px;

            .mobile-slider {
                display: block;
                padding-top: 20px;

                a {
                    display: block;
                    margin-bottom: 20px;
                }

                p {
                    max-width: 100%;
                }
            }
            .img-wrap {
                display: none;
            }
        }
        
        .section-6 {
            padding-left: 15px;
            padding-right: 15px;
            flex-direction: column;
            padding-bottom: 60px;

            .img-wrap {
                display: flex;
                justify-content: center;
            }

            .text-wrap {
                padding-left: 0px;
                line-height: 24px;
                max-width: 100%;
                padding-top: 25px;
            }
        }        
    `}
`
